<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-text>
          <h3 class="headline"><span v-t="'mainComponent.modalHeader'" /></h3>
          <span v-t="'mainComponent.modalSubHeader'" />
        </v-card-text>
        <div class="content-center">
          <v-subheader style="width: 80px">
            {{ $t('common.city') }}:
          </v-subheader>
          <v-btn
            :flat="selectedCity !== 1"
            large
            :color="selectedCity === 1 ? 'primary' : ''"
            :style="buttonsStyle"
            @click="selectCity(1)"
          >
            <v-icon large :color="selectedCity === 1 ? 'grey lighten-2' : 'grey'" class="mr-1">location_city</v-icon>
            <span>Kaunas</span>
          </v-btn>
          <v-btn
            :flat="selectedCity !== 2"
            :color="selectedCity === 2 ? 'primary' : ''"
            large
            :style="buttonsStyle"
            @click="selectCity(2)"
          >
            <v-icon :color="selectedCity === 2 ? 'grey lighten-2' : 'grey'" class="mr-1" large>location_city</v-icon>
            <span>Vilnius</span>
          </v-btn>
        </div>
        <v-divider />
        <div class="content-center">
          <v-subheader style="width: 80px">
            {{ $t('common.language') }}:
          </v-subheader>
          <v-btn
            :flat="selectedLanguage !== 1"
            large
            :color="selectedLanguage === 1 ? 'primary' : ''"
            :style="buttonsStyle"
            @click="selectLanguage(1)"
          >
            <v-icon large :color="selectedLanguage === 1 ? 'grey lighten-2' : 'grey'" class="mr-1">language</v-icon>
            <span>Lietuvių</span>
          </v-btn>
          <v-btn
            :flat="selectedLanguage !== 2"
            large
            :color="selectedLanguage === 2 ? 'primary' : ''"
            :style="buttonsStyle"
            @click="selectLanguage(2)"
          >
            <v-icon :color="selectedLanguage === 2 ? 'grey lighten-2' : 'grey'" class="mr-1" large>language</v-icon>
            <span>English</span>
          </v-btn>
        </div>
        <v-card-text>
          <v-icon class="mr-1" color="orange accent-2">info</v-icon>
          <span v-t="'mainComponent.balanceInfo'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" :disabled="!selectedCity || !selectedLanguage" @click="save">
            <span v-t="'common.save'" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'WelcomeModal',
  props: {
    displayName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      selectedCity: null,
      selectedLanguage: null,
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['userData']),
    buttonsStyle() {
      return this.$vuetify.breakpoint.smAndDown ? 'width: 120px' : 'width: 150px';
    },
  },
  methods: {
    ...mapActions('userInfoStore', ['updateUserData']),
    selectLanguage(language) {
      this.selectedLanguage = language;
      this.$i18n.locale = language === 1 ? 'lt' : language === 2 ? 'en' : 'en'; // eslint-disable-line no-nested-ternary
    },
    selectCity(city) {
      this.selectedCity = city;
    },
    save() {
      this.updateUserData({
        languageId: this.selectedLanguage,
        cityId: this.selectedCity,
        refetchDayDishesQuery: true,
      });
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.content-center {
  margin: auto;
  display: flex;
  justify-content: center;
}
</style>
